var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentAmexIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "#1F72CD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.34517 9L3.16406 16.2467H6.9723L7.44441 15.0913H8.52355L8.99566 16.2467H13.1875V15.3649L13.561 16.2467H15.7293L16.1028 15.3462V16.2467H24.8206L25.8807 15.1213L26.8732 16.2467L31.3509 16.2561L28.1597 12.6436L31.3509 9H26.9427L25.9108 10.1046L24.9495 9H15.4656L14.6513 10.8704L13.8178 9H10.0175V9.85186L9.59474 9H6.34517ZM7.08205 10.029H8.93836L11.0484 14.9431V10.029H13.0819L14.7117 13.5524L16.2137 10.029H18.237V15.2291H17.0059L16.9958 11.1544L15.2009 15.2291H14.0995L12.2946 11.1544V15.2291H9.76179L9.28162 14.0633H6.68745L6.20827 15.228H4.85123L7.08205 10.029ZM24.3696 10.029H19.3634V15.226H24.2921L25.8807 13.5036L27.4118 15.226H29.0124L26.686 12.6426L29.0124 10.029H27.4813L25.9007 11.7316L24.3696 10.029ZM7.98508 10.9089L7.1304 12.9856H8.83876L7.98508 10.9089ZM20.5997 12.055V11.1057V11.1048H23.7234L25.0864 12.6229L23.663 14.1493H20.5997V13.113H23.3308V12.055H20.5997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentAmexIcon);
export default __webpack_public_path__ + "static/media/Payment-amex-icon.8f432a5a5763e535a8da62f30494a137.svg";
export { ForwardRef as ReactComponent };